<template>
  <div>
    <common-dialog
      ref="dialog"
      width="500px"
      line-form
      title="选择冲销类型"
      :data="data"
      form-label-width="110px"
      :form-rules="rules"
      @closed="onClosed"
    >
      <template slot="form">
        <el-form-item label="冲销类型">
          <el-select v-model="data.BusinessType" @change="onChange">
            <el-option label="预收冲应收" :value="0"></el-option>
            <el-option label="预付冲应付" :value="1"></el-option>
            <el-option label="应收冲应收" :value="2"></el-option>
            <el-option label="应付冲应付" :value="3"></el-option>
            <el-option label="应收冲应付" :value="4"></el-option>
            <el-option label="应付冲应收" :value="5"></el-option> <!--hqq-->
          </el-select>
        </el-form-item>
        <el-form-item :label="FirstUnitLabel" prop="FirstUnitId">
          <select-input
            placeholder="请选择单位"
            :label="data.FirstUnitName"
            v-model="data.FirstUnitId"
            @click="openFirstUnit"
          />
        </el-form-item>
        <el-form-item label="转入结算单位" v-if="data.BusinessType>1" prop="SecondUnitId">
          <select-input
            placeholder="请选择单位"
            :label="data.SecondUnitName"
            v-model="data.SecondUnitId"
            @click="openSecondUnit"
          />
        </el-form-item>
        <el-form-item label="截止日期" prop="DocDateEnd">
          <range-picker
            style="border: none;margin-left: 9px; min-width: 180px;"
            :date="[data.DocDateStart, data.DocDateEnd]"
            @change="x=>{data.DocDateStart=x.Start;data.DocDateEnd=x.End;}"
            
          />
        </el-form-item>
      </template>
      <template slot="footer">
        <el-button type="primary" @click="save">保 存</el-button>
        <el-button @click="close">关 闭</el-button>
      </template>
      <!-- 后面补充 -->
      <tradeunit-dialog ref="firstUnit" in-dialog selectable @select="setFirstUnit" />
      <tradeunit-dialog ref="secondUnit" in-dialog selectable @select="setSecondUnit" />
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import tradeunitDialog from "@/components/basedata/business/come/listDialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    tradeunitDialog,
  },
  data() {
    return {
      data: {
        BusinessType: 0, //预收冲应收、预付冲应付、应收冲应收、应付冲应付、应收冲应付、应付冲应收
        FirstUnitId: null,
        FirstUnitName: "",
        SecondUnitId: null,
        SecondUnitName: "",
        DocDateStart: this.$commonJs.getToday(),
        DocDateEnd: this.$commonJs.getToday(),
      },
      isSave: false,
      saveDto: null,
      rules: {
        FirstUnitId: [{ required: true, message: "请选择转出结算单位" }],
        SecondUnitId: [{ required: true, message: "请选择转入结算单位" }],
        DocDateEnd: [{ required: true, message: "截止日期不能为空" }],
      },
    };
  },
  computed: {
    FirstUnitLabel() {
      if (this.data.BusinessType < 2) return "往来单位";
      else return "转出结算单位";
    },
  },
  methods: {
    onChange() {
      this.$refs.dialog.clearValidate();
      this.data.FirstUnitId = null;
      this.data.FirstUnitName = "";
      this.data.SecondUnitId = null;
      this.data.SecondUnitName = "";
    },
    openFirstUnit() {
      this.$refs.firstUnit.open().then((that) => {
        that.getData({Status:1});
      });
    },
    setFirstUnit(data) {
      this.data.FirstUnitId = data.TradeUnitId;
      this.data.FirstUnitName = data.FullName;
    },
    openSecondUnit() {
      this.$refs.secondUnit.open().then((that) => {
        that.getData({Status:1});
      });
    },
    setSecondUnit(data) {
      this.data.SecondUnitId = data.TradeUnitId;
      this.data.SecondUnitName = data.FullName;
    },
    save() {
      this.$refs.dialog.formValidate().then((valid) => {
        if (!valid) return;

        this.isSave = true;
        this.saveDto = { ...this.data };
        this.close(true);
      });
    },
    onClosed() {
      if (this.isSave) this.$emit("confirm", { ...this.saveDto });
      this.isSave = false;
    },
  },
};
</script>